import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Shield, Users, BarChart3 } from "lucide-react";
import { Link } from "react-router-dom";
function HomePage() {
  function Feature({ text }) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-600">
        <div className="w-2 h-2 bg-success rounded-full"></div>
        {text}
      </div>
    );
  }

  // Helper Component for Feature Block
  function FeatureBlock({ icon, title, description, bg }) {
    return (
      <div className="text-center">
        <div
          className={`w-12 h-12 ${bg} rounded-lg flex items-center justify-center mx-auto mb-4`}
        >
          {icon}
        </div>
        <h3 className="font-semibold text-slate-900 mb-2">{title}</h3>
        <p className="text-sm text-slate-600">{description}</p>
      </div>
    );
  }
  return (
    <>
      <div className="min-h-screen bg-slate-50">
        {/* Header */}
        <header className="bg-white border-b border-slate-200">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-comerco-primary rounded-lg flex items-center justify-center">
                <Shield className="text-white" size={18} />
              </div>
              <div>
                <h1 className="text-xl font-semibold text-slate-900">
                  Comerco Protection
                </h1>
                <p className="text-sm text-slate-500">
                  AI-Driven Claims System
                </p>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-4">
              Welcome to Comerco Claims System
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Experience our AI-powered protection plan claims system designed
              for both customers and agents.
            </p>
          </div>

          {/* Portal Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center gap-3">
                  <Users className="text-comerco-primary" size={24} />
                  Claimant Portal
                </CardTitle>
                <CardDescription>
                  File your protection plan claim through our conversational AI
                  interface
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3 mb-6">
                  <Feature text="Mobile-optimized chat interface" />
                  <Feature text="Quick replies and guided flow" />
                  <Feature text="Evidence upload with progress tracking" />
                  <Feature text="Real-time claim status updates" />
                </div>
                <Link to="/createticket">
                  <Button className="w-full bg-comerco-primary hover:bg-blue-700">
                    Start Filing Claim
                  </Button>
                </Link>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center gap-3">
                  <BarChart3 className="text-comerco-primary" size={24} />
                  Admin Portal
                </CardTitle>
                <CardDescription>
                  Review and manage claims with AI-powered insights and
                  analytics
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3 mb-6">
                  <Feature text="Interactive AI analysis workspace" />
                  <Feature text="Advanced filtering and search" />
                  <Feature text="Real-time dashboard metrics" />
                  <Feature text="Collaborative agent tools" />
                </div>
                <Link to="/dashboard">
                  <Button className="w-full bg-comerco-primary hover:bg-blue-700">
                    Access Admin Portal
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </div>

          {/* Features Section */}
          <div className="mt-16 text-center">
            <h2 className="text-2xl font-bold text-slate-900 mb-8">
              AI-First, Human-Centric Design
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <FeatureBlock
                icon={<Shield className="text-comerco-primary" size={24} />}
                title="Intelligent Automation"
                description="AI handles routine claim processing while humans focus on complex cases"
                bg="bg-blue-100"
              />
              <FeatureBlock
                icon={<Users className="text-success" size={24} />}
                title="Collaborative Workspace"
                description="Seamless handoff between AI analysis and human agent review"
                bg="bg-green-100"
              />
              <FeatureBlock
                icon={<BarChart3 className="text-warning" size={24} />}
                title="Real-time Insights"
                description="Live analytics and performance metrics for continuous improvement"
                bg="bg-amber-100"
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
export default HomePage;
